import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-signature.vue";
import mobile from "./components/mobile-signature.vue";
export const info = {
    title: "手写签名",
    type: "signature",
    icon: "h-icon-all-edit-o",
    dataItemType: DataItemType.Attachment,
    formControllerType: FormControlType.Signature,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
